import {
  Box, Card, CardBody, Tabs,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Form from '@submize/form';
import PreviewMenu from './PreviewMenu';
import MainPanel from '../../Components/Layouts/MainPanel';
import ContentPanel from '../../Components/Layouts/ContentPanel';
import { getForm } from '../../Components/FormSetup/formSlice';
import { useSchema } from '../../helpers/schema';
import Frame from '../../Components/Frame';

const PreviewForm = () => {
  const form = useSelector(getForm);
  const schema = useSchema();
  const navigate = useNavigate();
  const [size, setSize] = useState('100%');

  const onDeviceChange = (e) => {
    const sizes = {
      0: '100%',
      1: '810px',
      2: '360px',
    };
    setSize(sizes[e] || '100%');
  };
  useEffect(() => {
    if (!form.initiated) {
      navigate('../edit');
    }
  }, [form.initiated]);
  return (
    <Box>
      <Tabs size="xs" variant="unstyled" defaultIndex={0} onChange={onDeviceChange}>
        <MainPanel w="100%">
          <ContentPanel display="flex" flexDir="column" alignItems="center">
            <PreviewMenu />
            <Card maxW={size} height="100%" w="100%" overflow="hidden" pt="0">
              <Frame title="form preview 1" height="100%">
                <CardBody id="preview" minH="calc(100vh - 200px)">
                  <Form onSubmit={() => {}} schema={schema.schema} />
                </CardBody>
              </Frame>
            </Card>
          </ContentPanel>
        </MainPanel>
      </Tabs>
    </Box>
  );
};

export default PreviewForm;
